import { Outlet } from "react-router";
import {
  LogoutButton,
  NavbarDropdown,
  NavbarLink,
  NavbarTextWithIndicator,
  SlideNavbarLink,
} from "./NavComponents";
import { screenTypesArray } from "../utils/slideTemplateAllocation";
import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { useEffect, useState } from "react";
import {
  hostDataAtom,
  loginStatusAtom,
  modelDataAtom,
  userAtom,
} from "../atoms";
import apiAgent from "../api/apiAgent";
import { transformModelSchema } from "../utils";
import { Loader } from "../components/Loader";
import {
  schoolphotosPublishAtom,
  slidesPublishAtom,
} from "../components/Publishing/atoms";
import { getPublishStates } from "../components/Publishing/utils";
import { IModelData } from "../atoms";

/**
 * Modify this fo adjust menu items
 * @returns Navbar Menu
 */

const NavbarLayout = () => {
  const setModelData = useSetAtom(modelDataAtom);
  const setHostData = useSetAtom(hostDataAtom);
  const user = useAtomValue(userAtom);
  const [loginStatus, setLoginStatus] = useAtom(loginStatusAtom);
  const [modelsLoaded, setModelsLoaded] = useState<boolean>(false);
  const [hostDataLoaded, setHostDataLoaded] = useState<boolean>(false);

  const [schoolPhotosPublished, setSchoolphotosPublished] = useAtom(
    schoolphotosPublishAtom
  );
  const [slidesPublished, setSlidesPublished] = useAtom(slidesPublishAtom);

  useEffect(() => {
    if (loginStatus === true) {
      if (!modelsLoaded) fetchModelData();
      if (!hostDataLoaded) fetchHostData();
      getPublishStates("schoolphotos", setSchoolphotosPublished);
      getPublishStates("slides", setSlidesPublished);
    }
  }, [loginStatus]);

  const fetchHostData = async () => {
    try {
      const response = await apiAgent.Hosting.get();
      if (response.status === 200) {
        setHostData(response.data);
        setHostDataLoaded(true);
      } else if (response.status === 401) {
        setLoginStatus(false);
      }
    } catch (err) {
      console.log("Could not set host data", err);
    }
  };

  const fetchModelData = async () => {
    try {
      const response = await apiAgent.Models.getAll();
      if (response.status === 200) {
        // Since the CMS also allows managing "users" (a system model), add that here too
        const userModel: IModelData = response.data.systemModels.find(
          (sm: any) => sm.name === "users"
        );
        const allModels: IModelData[] = [userModel, ...response.data.models];

        const modelData = transformModelSchema(allModels);
        console.log("Model data loaded:", modelData);
        setModelData(modelData);
        setModelsLoaded(true);
      } else if (response.status === 401) {
        setLoginStatus(false);
      }
    } catch (err) {
      console.log("Could not load modelData");
    }
  };

  const screens = screenTypesArray.filter((item) => item.id !== 900);

  return (
    <div className="w-full h-full min-h-fit min-w-[60rem] flex bg-sidebarBg">
      <div className="w-[16rem] flex flex-col">
        <div className="p-8 w-full flex justify-center">
          <img src="/assets/ns_sidebar_logo.png" className="w-[11rem]" />
        </div>
        <NavbarLink to="/home">Home</NavbarLink>
        <NavbarLink to="/m/schoolphotos">
          <NavbarTextWithIndicator publishObj={schoolPhotosPublished}>
            School Photos
          </NavbarTextWithIndicator>
        </NavbarLink>
        <NavbarLink to="/m/studentworks">
          <NavbarTextWithIndicator publishObj={schoolPhotosPublished}>
            Student Work
          </NavbarTextWithIndicator>
        </NavbarLink>
        <NavbarDropdown
          label={
            <NavbarTextWithIndicator publishObj={slidesPublished}>
              Digital Signage
            </NavbarTextWithIndicator>
          }
        >
          {screens.map((screenType, index) => (
            <SlideNavbarLink key={index} screenId={screenType.id}>
              {screenType.name}
            </SlideNavbarLink>
          ))}
        </NavbarDropdown>
        {user?.user_role === "admin" && (
          <NavbarLink to="/m/users">Manage Users</NavbarLink>
        )}
        <div className="w-full flex-grow " />
        <div className="w-full text-center text-sm pb-2">
          Logged in as <span className="font-bold">{user?.username}</span>
        </div>
        <LogoutButton />
      </div>
      <div className="w-[calc(100%-16rem)] h-full bg-white text-black">
        {modelsLoaded ? (
          <Outlet />
        ) : (
          <div className="w-full h-full text-center grid content-center text-grayText">
            <Loader />
            <div className="my-4">loading model data... Please wait</div>
          </div>
        )}
      </div>
    </div>
  );
};

export { NavbarLayout };
